export async function saveFileWithPicker(documentData, filename) {
  if ('showSaveFilePicker' in window) {
    try {
      // Determine MIME type based on file extension
      let mimeType = 'application/octet-stream'; // default fallback
      if (filename.endsWith('.pdf')) mimeType = 'application/pdf';
      else if (filename.endsWith('.txt')) mimeType = 'text/plain';
      else if (filename.endsWith('.csv')) mimeType = 'text/csv';
      else if (filename.endsWith('.docx')) mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      else if (filename.endsWith('.xlsx')) mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      else if (filename.endsWith('.xls')) mimeType = 'application/vnd.ms-excel';

      // Ensure data is a Blob with the correct type
      const blobData = documentData instanceof Blob
        ? documentData
        : new Blob([documentData], { type: mimeType });

      const handle = await window.showSaveFilePicker({
        suggestedName: filename,
        types: [
          {
            description: 'Supported Files',
            accept: { [mimeType]: [`.${filename.split('.').pop()}`] }
          }
        ]
      });

      const writable = await handle.createWritable();
      await writable.write(blobData);
      await writable.close();
      console.log('File saved successfully!');
    } catch (err) {
      if (err.name === 'AbortError') {
        console.log('User cancelled the save dialog. No file was saved.');
        return;
      }
      console.error('Error using File System API:', err);
      alert('Saving file failed. Please try again.');
    }
  } else {
    alert('Your browser does not support file picker. Please update your browser.');
  }
}
